module.exports = __webpack_public_path__ + "static/img/thermal_comfort.3410ff70.png";